import React from "react";
import BackendCall from "../institute/BackendCall";

function MajorActivities() {
  return (
    <>
      <BackendCall />

      <section className="activities">
        <h1 className="heading">
          <span>major activities</span>
        </h1>
        <div className="container">
        <div className="container-content">
            <p className="urdu">
              بچوں اور نوجوانوں کی ورکشاپیں کروانا
              <span>ہم بچوں اور نوجوانوں کے لئے خصوصی طور پر تشکیل دیے گئے ورکشاپس کا منظم کرتے ہیں۔ یہ ورکشاپس قرآنی اور اسلامی تعلیم کے مختلف پہلوؤں پر توجہ مرکوز کرتے ہیں اور بچوں اور نوجوانوں کو متعامل اور دلچسپ سیکھنے کی تجربہ کاری فراہم کرتے ہیں۔ ہم ان ورکشاپس کے ذریعے قرآن اور اسلام کی محبت کو </span>
            </p>
            <p className="urdu">
              قرآنی اور اسلامی آن لائن اور حضوری کلاسز کروانا
              <span>ہم مختلف عمریں اور زمینے کے لوگوں کی ضروریات کو پورا کرنے کیلئے قرآنی اور اسلامی آن لائن کلاسوں کی پیشکش کرتے ہیں۔ یہ آن لائن کلاسیں قرآنی تلاوت، تجوید، قرآنی تشریح اور اسلامی مطالعات سیکھنے کے لئے ایک آسان اور قابل رسائی پلیٹ فارم فراہم کرتی ہیں۔ ہمارے تجربہ کار اساتذہ طلبہ کے لئے ایک مکمل </span>
            </p>
            <p className="urdu">
              قرآن سنٹرز بنانا اور فعال کرنا
              <span>ہم قرآنی تعلیم اور سرگرمیوں کیلئے مختلف مقامات میں قرآنی مراکز کے قیام اور فعالیت کو مختص کرنے کے لئے مخصوص وقت اور توجہ زور دیتے ہیں۔ یہ قرآنی مراکز قرآنی تعلیم اور سرگرمیوں کے لئے بنیادی مراکز کی حیثیت رکھتے ہیں۔ یہاں قرآن کی تعلیم، حفظ اور سمجھ کے لئے مناسب ماحول فراہم کیا جاتا ہے، اس کے </span>
            </p>
            <p className="urdu">
              قرآنی اساتذہ کی تربیت کرنا
              <span>ہم قرآنی اساتذہ بننے کے خواہشمند افراد کے لئے مخصوص تربیتی پروگرامات پیش کرتے ہیں۔ ہماری تربیتی پروگرام سے خواہشمند اساتذہ کو قرآن کی تعلیم دینے کے لئے ضروری ہنر، علم اور تدریسی تقنیات سے لیس کیا جاتا ہے۔ مکمل تربیت کے ذریعے ہم مقتدر اور مخلص قرآنی اساتذہ تیار کرنے کا مقصد رکھتے ہیں</span>
            </p>
            <p className="urdu">
              قرآنی سلیبس تیار کرنا
              <span>ہم مختلف عمری گروپ اور سطحوں کی ضروریات کو پورا کرنے والے مکمل قرآنی نصابی موادیں تیار کرتے ہیں۔ ہمارا نصاب قرآن حفظ، تجوید، قرآنی تشریح اور اسلامی تعلیمات وغیرہ کے مختلف پہلوؤں کو شامل کرتا ہے۔ محتاطانہ تشکیل شدہ نصاب طلبہ کے لئے ایک ساختہ اور تدریجی سیکھنے کا سفر فراہم کرتا ہے</span>
            </p>
            <p className="urdu">
              قرآن اور اسلام سے متعلق شبہات کی جواب دہی
              <span>ہم افراد کے لئے ایک پلیٹ فارم فراہم کرتے ہیں تاکہ وہ قرآن اور اسلام کے بارے میں اپنے شبہات اور سوالات کا راہ نکشی کرسکیں۔ ہمارے عالمانہ و مستند علماء اور تربیت یافتہ اساتذہ دستیاب ہیں تاکہ وہ سوالات کا جواب دیں، قرآنی تصورات کی وضاحت کریں، اور اسلام کے بارے میں درست معلومات فراہم کریں۔ ہم اصولی گفتگو اور درست معلومات کے ذریعے سمجھ و تفہیم کو فروغ دینے کا مقصد رکھتے ہیں</span>
            </p>
          </div>
          <div className="container-content intro">
            <p className="english">
              Conducting workshops for children and youth
              <span>
                We organize workshops designed specifically for children and
                youth. These workshops focus on various aspects of Quranic and
                Islamic education, providing them with an interactive and
                engaging learning experience. Through these workshops, we aim to
                instill a love for Quran and Islam while enhancing their
                knowledge and understanding.
              </span>
            </p>
            <p className="english">
              Conducting Quranic and Islamic online classes
              <span>
                We offer Quranic and Islamic online classes to cater to the
                needs of individuals of all ages and backgrounds. These online
                classes provide a convenient and accessible platform for
                learning Quranic recitation, Tajweed, Quranic interpretation,
                and Islamic studies. Our experienced instructors ensure a
                comprehensive and engaging learning environment for students.
              </span>
            </p>
            <p className="english">
              Creation and activation of Quran Centers
              <span>
                We are dedicated to the establishment and activation of Quran
                centers in different locations. These Quran centers serve as
                hubs for Quranic education and activities. They provide a
                conducive environment for learning, memorizing, and
                understanding the Quran, along with offering various programs
                and events to promote Quranic teachings.
              </span>
            </p>
            <p className="english">
              To train Quranic teachers
              <span>
                We offer specialized training programs for individuals
                interested in becoming Quranic teachers. Our training equips
                aspiring teachers with the necessary skills, knowledge, and
                pedagogical techniques to effectively teach the Quran and impart
                its teachings to others. Through comprehensive training, we aim
                to develop competent and dedicated Quranic teachers.
              </span>
            </p>
            <p className="english">
              Preparation of Quranic Syllabus
              <span>
                We develop comprehensive Quranic syllabus materials that cater
                to different age groups and learning levels. Our syllabus
                encompasses various aspects of Quranic education, including
                Quran memorization, Tajweed, Quranic interpretation, and Islamic
                teachings. The carefully designed syllabus ensures a structured
                and progressive learning journey for students.
              </span>
            </p>
            <p className="english">
              Answering Doubts About Quran and Islam
              <span>
                We provide a platform for individuals to seek clarification and
                answers to their doubts and questions about the Quran and Islam.
                Our team of knowledgeable scholars and educators are available
                to address inquiries, explain Quranic concepts, and provide
                authentic information about Islam. We strive to promote
                understanding and dispel misconceptions through open dialogue
                and accurate information.
              </span>
            </p>
          </div>

          
        </div>
      </section>
    </>
  );
}

export default MajorActivities;
